import { scrollbar } from "src/styles/mixins";
import styled, { css } from "styled-components";

export const StyledEditableTextArea = styled.textarea<{
  isTaskCard?: boolean;
  numOfChars?: number;
  isAddedTask?: boolean;
}>`
  margin: 0;
  padding: 0;
  margin-left: ${({ isTaskCard }) => (isTaskCard ? "24px" : 0)};

  border: none;
  outline: none;
  resize: none;
  overflow-x: hidden;
  height: 20px;
  max-height: 60px;

  width: ${({ numOfChars }) => {
    const w = numOfChars && numOfChars * 14 + 10;
    return w && w < 180 ? w + "px" : "180px";
  }};

  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xxxs};
  font-weight: ${({ isTaskCard, theme }) =>
    isTaskCard ? theme.fonts.weights.bold : theme.fonts.weights.bolder};

  &:focus {
    outline: none;
  }

  &:disabled {
    color: ${({ isAddedTask, theme }) =>
      isAddedTask ? theme.colors.primary : theme.colors.inactiveTaskName};
    background-color: ${({ theme }) => theme.colors.background};
  }

  ${({ isTaskCard }) =>
    isTaskCard &&
    css`
      text-align: center;
    `};

  @media ${({ theme }) => theme.mq.md} {
    font-size: ${({ theme, isTaskCard }) => isTaskCard && theme.fonts.sizes.s};
    height: 32px;
    max-height: 96px;

    line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
    width: ${({ numOfChars }) => {
      const w = numOfChars && numOfChars * 14 + 10;
      return w && w < 380 ? w + "px" : "380px";
    }};
  }

  ${scrollbar}
`;
